declare var google: any;
import { Component, OnInit, ViewChild,NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { HospitalService } from 'src/app/services/hospital.service';
import { DatePipe } from '@angular/common';
import { WindowreffService } from 'src/app/services/windowreff.service';


@Component({
  selector: 'app-hospital-detail',
  templateUrl: './hospital-detail.component.html',
  styleUrls: ['./hospital-detail.component.css']
})
export class HospitalDetailComponent implements OnInit {
  hospitalDetail:any={
    treatments:[],
    services:[],
    blogs:[],
    doctors:[],
    ambulance:[],
    images:[],
    review:[]
  }
  logintype: string = localStorage.getItem('usertype')
  sessionStoreURL = localStorage.getItem('sesssionUrl')
  token: string
  imageUrlArray:any=[]
  showDateWithDay:any = []
  bookingDay:any='Today'
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  options = {
    types: [],
    componentRestrictions: {country: 'in'}
  }
  bookObject: any = {
    address: '',
    lat: '',
    lng: '',
    phoneNo: ''
  }
  sendBookingData:any={
    bookingDate:'',
    startTime:'',
    
    treatments:[]
  }
  totalAmount:number=0
  sendTreatments:any=''
  morningSlots:any = [] 
  afterNoonSlots:any = []
  eveningSlots:any = []
  treatmentError:boolean=false
  startTimeError:boolean=false
  otpBookingServer: string
  otpValObj1_booking: string
  otpValObj2_booking: string
  otpValObj3_booking: string
  otpValObj4_booking: string
//phoneNo:Number
  isLoggedIn: boolean = localStorage.getItem('token') ? true : false
  verifyOtpError_Booking: boolean = false
  flag2 = true


  slideConfig = {
    infinite: false,
    speed: 300,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  };

  slideConfigCustomers = {
    infinite: true,
    speed: 300,
    arrows: false,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };
  finalObj:any={
    customerDetail:{
      name:'',
      phone:'',
      email:''
    },
    cardDetail:{
      cardNumber:'',
      cardExpDate:'',
      cardCvv:'',

    },
    addressDetail:{
      address:'',
      landmark:'',
      city:'',
      state:'',
      pincode:''
    }
  }

  

  constructor(private route: ActivatedRoute,
    private auth: AuthService,
     public http: HttpClient,
      public router: Router,
       private toaster: ToastrService,
       public hospitalSvc:HospitalService,
       public datepipe: DatePipe,
       private winRef: WindowreffService,
       private ngZone:NgZone
       ) {
    this.auth.isLoggedinForHome.subscribe(data => {

      this.isLoggedIn = data
      if (data)
        this.bookObject['phoneNo'] = JSON.parse(localStorage.getItem('logindata'))['phoneNo']

    })

    this.auth.getMapData().subscribe(res => {
      let checkData = res['data'];
      if (checkData.length) {
        this.router.navigate(['/ambulance-tracking'])
      } 
    });

   }

  ngOnInit() {
    localStorage.removeItem('hospitalBookingData')
    //console.log(this.route.snapshot.params.id)
    if(this.route.snapshot.params.id){
      this.hospitalDetail.averageRatings=0
      let date = new Date();
      let latest_date =this.datepipe.transform(date, 'dd-MM-yyyy');
      this.hospitalDetail.averageRatings=0
      this.getHospitalDetail(this.route.snapshot.params.id,latest_date)
      this.showDateswithDay()
    localStorage.setItem('hospitalId',this.route.snapshot.params.id)
    }

    this.auth.getLocation().then(location => {
      // console.log(location.lat)
      // console.log(location.lng)
      this.bookObject['lat'] = location.lat
      this.bookObject['lng'] = location.lng

      this.getAddress(location.lat, location.lng);


    })
    this.isLoggedIn = this.auth.isLoggedin
   // console.log(this.auth.partner['phoneNo'])
    if (this.isLoggedIn)
      this.bookObject['phoneNo'] = JSON.parse(localStorage.getItem('logindata'))["phoneNo"]
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
}
  getPriceAfterDiscount(price,discount){
    let priceTemp =  price-(price*discount/100)
    return priceTemp==0 ? 'Free' : price-(price*discount/100)
 
  }
  getPriceAfterDiscount1(price,discount){
    let priceTemp =  price-(price*discount/100)
    
       return priceTemp
     }
  findAlreadyAdded(record){

    let check = this.sendBookingData.treatments.findIndex(treatment=>treatment.treatmentId==record._id)
  
  if(check>-1){
    return true
  
  }
  else{
    return false
  }
  }
  onCheckboxChange(option, event) {
  
    if(event.target.checked) {
      this.treatmentError=false
      console.log(option)
      let obj={treatmentId:option._id,name:option.name,price:this.getPriceAfterDiscount1(option.price,this.hospitalDetail.discount)}
      
      this.sendBookingData.treatments.push(obj);
    } else {
    for(var i=0 ; i < this.sendBookingData.treatments.length; i++) {
      if(this.sendBookingData.treatments[i].treatmentId == option._id) {
        this.sendBookingData.treatments.splice(i,1);
     }
   }
  
  
  }
  console.log(this.sendBookingData)
  
  
  
  }
  Booking(flag){
    if(this.sendBookingData.startTime==''){
      this.startTimeError=true
      this.treatmentError =false
      document.getElementById('slot_popup_trigge_doctor').click()
    }
    else if(this.sendBookingData.treatments.length==0){
      this.treatmentError=true
      this.startTimeError=false
      document.getElementById('treatment_popup_trigge_doctor').click()
    }
     
    else
    {
      if(!flag){
       document.getElementById('treatment_popup_trigge_doctor').click()
      }
      this.startTimeError=false
      this.treatmentError =false
  
  
    let token =localStorage.getItem('token')
    let usertype =localStorage.getItem('usertype')
    if(token!=null && usertype=='User'){
      this.sendTreatments =  this.sendBookingData.treatments.map(e => e.name).join(",");
      this.totalAmount =  this.sendBookingData.treatments.reduce( 
        (a: number, b) => a + b.price, 0);
  
    document.getElementById('booking_doctor_trigge_doctor').click()
  
  
      
    }
      
    else{
      this.sendTreatments =  this.sendBookingData.treatments.map(e => e.name).join(",");
          this.totalAmount =  this.sendBookingData.treatments.reduce( 
            (a: number, b) => a + b.price, 0);
      localStorage.setItem('hospitalBookingData',JSON.stringify(this.sendBookingData))
      document.getElementById('logintoggle_user').click()
    }
  }
  
    console.log(this.sendBookingData)
  }
  timeSet(status,time,slot){
    if(!status){
      this.afterNoonSlots.map(slot=>slot.selected=false)
      this.morningSlots.map(slot=>slot.selected=false)
      this.eveningSlots.map(slot=>slot.selected=false)
  
      slot.selected =true
      this.sendBookingData.startTime = time
   
    }
    else
      console.log('disabled')
  }
  showDateswithDay(){
    this.showDateWithDay=[]
    var currentDate = new Date();
    let latest_date =this.datepipe.transform(currentDate, 'dd-MM-yyyy');
    this.sendBookingData.bookingDate = latest_date
    this.showDateWithDay.push({ selected:true,sendDate:this.datepipe.transform(currentDate,'dd-MM-yyyy') ,day:'Today',showdate:this.datepipe.transform(currentDate,'dd 	LLL') })
      let i=1
      while(i<4){
      currentDate.setDate(currentDate.getDate() + 1);
      this.showDateWithDay.push({ selected:false,sendDate:this.datepipe.transform(currentDate,'dd-MM-yyyy') ,day:this.datepipe.transform(currentDate,'E'),showdate:this.datepipe.transform(currentDate,'dd 	LLL') })
      i++
      }
    
  }
  showAllBlogs(){
    this.imageUrlArray = this.hospitalDetail.blogs
    document.getElementById('orderImagesCLick').click()
  }
  handleAddressChange(address: Address) {
    console.log(address.geometry.location.lat())
    this.bookObject["lat"] = address.geometry.location.lat()
    this.bookObject["lng"] = address.geometry.location.lng()
    console.log(address.formatted_address)
    this.bookObject["address"] = address.formatted_address

    localStorage.setItem('currentaddress', address.formatted_address);


  }
  getCurrentLocation() {
    if(!this.isLoggedIn){
      this.bookObject['name'] = ''
      this.bookObject['phoneNo'] = ''
    }
    // this.bookObject['name'] = '';
    // this.bookObject['phoneNo'] = '';
    this.bookObject['phoneNo'] = localStorage.getItem('phoneNo');
    this.bookObject['address'] = localStorage.getItem('currentaddress');
  }
  getAddress(lat, lng) {
    var latlng = new google.maps.LatLng(lat, lng);
    var geocoder = geocoder = new google.maps.Geocoder();
    geocoder.geocode({'latLng': latlng}, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        console.log(results[1])
        if (results[1]) {
          localStorage.setItem('currentaddress', results[1].formatted_address)
        } else {
          return ''
        }

      }
    });
  }
  bookAmbulance_without_login() {
    

    if (this.bookObject.phoneNo) {


      let len = this.bookObject.phoneNo.toString();

      console.log(len.length, 'this.bookObject.phoneNo.length');

      if (len.length <= 15 && len.length >= 6) {
        this.auth.getOtp(this.bookObject["phoneNo"], 'User').subscribe((res: any) => {
            console.log(res);
            if (res.statusCode == 200) {
              this.otpBookingServer = res.data;
              document.getElementById('loginEmergency').click();
              document.getElementById('booking_otp_trigger').click();
            }

            //this.router.navigate(['/ambulance-tracking'])
          },
          error => {
            console.log(error);
          })
      } else {
        this.toaster.error('Contact number length should be 6-16 characters', 'Error', {
          timeOut: 2000
        });
      }
    } else {
      this.toaster.error('Please enter contact number', 'Error', {
        timeOut: 2000
      });
    }

  }

  checkOtpfuncUserBookingLogin() {

    let otp_val = this.otpValObj1_booking + '' + this.otpValObj2_booking + '' + this.otpValObj3_booking + '' + this.otpValObj4_booking
    this.auth.checkOtpfunc(this.bookObject.phoneNo, otp_val, 'User').subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyOtpError_Booking = false
        this.bookAmbulance(false)

      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      console.log(error)
      this.verifyOtpError_Booking = true
      localStorage.clear()
    })
  }

  resendOtp() {

    this.auth.bookAmbulance(this.bookObject).subscribe((res: any) => {
        console.log(res)
        if (res.statusCode == 200) {
          this.otpBookingServer = res.data.otp
          this.toaster.success('Otp Sent....', 'Success', {
            timeOut: 2000
          });
        } else {
          this.toaster.error('There was some Error sending the Otp...', 'Error', {
            timeOut: 2000
          });
        }

        //this.router.navigate(['/ambulance-tracking'])
      },
      error => {
        this.toaster.error('There was some Error sending the Otp...', 'Error', {
          timeOut: 2000
        });
        console.log(error);
      }
    )


  }

  bookAmbulance(flag: boolean) {
    this.auth.bookAmbulance(this.bookObject).subscribe((res1: any) => {
      console.log(res1)
      if (res1.statusCode == 200) {
        localStorage.setItem('ambulanceId', res1.data.ambulanceId)

        // document.getElementById('loginEmergency').click()
        if (!flag) {

          this.isLoggedIn = true
          this.auth.isLoggedin = true
          document.getElementById('booking_otp_trigger').click()
        } else {
          document.getElementById('loginEmergency').click()
        }

        this.router.navigate(['/ambulance-tracking'])
      }
    })
  }

  numberOnly(event, id): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (id != null)
      document.getElementById(id).focus()
    return true;

  }

  getHospitalDetail(hospitalId:string,date){
    this.hospitalSvc.getHospitalDetail(hospitalId).subscribe(res=>{
      console.log(res)
      
      this.hospitalDetail = res["data"][0]
      this.slotAssign(this.hospitalDetail.slots,date)
    },error=>{

    })
  }
  slotAssign(slots,date){
    this.morningSlots = []
    this.afterNoonSlots = []
    this.eveningSlots = []
  slots.map(slot=>{
    this.assignSlotsEach(slot.time,slot.status,date)
    //this.assignSlotsEach(slot.time,false,date) // for testing
  })
  
  
  }
  assignSlotsEach(time,status,date){
    let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    let time2:any
    
  
    if (time1.length > 1) { // If time format correct
       time2 = time1.slice (1);  // Remove full string match value
      time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
      time2[0] = +time2[0] % 12 || 12; // Adjust hours
    }
    
   
   if(time2[0]<=12 && time2[5]==' am'){
   // this.morningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
     if( this.sendBookingData.bookingDate==this.datepipe.transform(new Date(),'dd-MM-yyyy') ){
    //  countryCode: "91"
      if(new Date().getHours()>=parseInt(time.split(':')[0]))
      {
        this.morningSlots.push({time:time2.join(''),status:true,sendTime:time,selected:false})
      }
      else{
        this.morningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
      }
     }
  
    else {
      this.morningSlots.push({time:time2.join(''),status:false,sendTime:time,selected:false})
    
   }
  }
  
   if( (time2[0]==1 || time2[0]==2 || time2[0]==3 || time2[0]==12) && time2[5]==' pm'){
  //  this.afterNoonSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
     //console.log(time2)
     if( this.sendBookingData.bookingDate==this.datepipe.transform(new Date(),'dd-MM-yyyy') ){
      if(new Date().getHours()>=parseInt(time.split(':')[0]))
    {
      this.afterNoonSlots.push({time:time2.join(''),status:true,sendTime:time,selected:false})
    }
    else{
    this.afterNoonSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
    }
    }
    else{
      this.afterNoonSlots.push({time:time2.join(''),status:false,sendTime:time,selected:false})
    }
    
  }
  if(time2[0]<12 && time2[0]>=4  && time2[5]==' pm'){
   // this.eveningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
    if( this.sendBookingData.bookingDate==this.datepipe.transform(new Date(),'dd-MM-yyyy') )
    {
      if(new Date().getHours()>=parseInt(time.split(':')[0]))
    {
      this.eveningSlots.push({time:time2.join(''),status:true,sendTime:time,selected:false})
    }
    else{
      this.eveningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
    }
    }
    else{
      this.eveningSlots.push({time:time2.join(''),status:false,sendTime:time,selected:false})
    }
   
  
  
  }

  
  }
  payWithRazor(){ 
    if(this.totalAmount==0){
      document.getElementById('booking_doctor_trigge_doctor').click()
      this.bookHospital()
    }
    else{
    document.getElementById('booking_doctor_trigge_doctor').click()
    let options:any = {
      "key": "rzp_live_YmyxdRilAgKlpK",// test key :rzp_test_dvfpRNEUlLTuCq
        "amount": this.totalAmount*5,
        "name": "Daktarz",
        "description": "Hospital Doctor Booking",
       // "image": "../assets/images/logo.png",
        "modal": {
          "escape": false
        }, 
        "prefill": {
          "name": this.finalObj.customerDetail.name,
          "contact": this.finalObj.customerDetail.phone,
          "email": this.finalObj.customerDetail.email,
          "method": 'card',
          'card[number]': this.finalObj.cardDetail.cardNumber,
          'card[expiry]': this.finalObj.cardDetail.cardExpDate,
          'card[cvv]': this.finalObj.cardDetail.cardCvv
        },
        "notes": {
          "address": this.finalObj.addressDetail.address + ', ' + this.finalObj.addressDetail.landmark + ', ' + this.finalObj.addressDetail.city + ', ' + this.finalObj.addressDetail.state + '-' + this.finalObj.addressDetail.pincode
        },
        "theme": {
          "color": "#26abe3"
        }
      };
      options.handler = ((response) => {
        console.log(response)
          if(response.razorpay_payment_id){
            this.sendBookingData["transactionId"] = response.razorpay_payment_id
            this.bookHospital()
          }
        // this.paymentService.payWithRazor({cart: this.finalObj, payment: options});
      });
      options.modal.ondismiss = (() => {
        //  this.loginService.SetLoader = false;
      });
      let rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
    }
  }
  showImagePopup(image){
    this.imageUrlArray=[]
    this.imageUrlArray.push(image)
    document.getElementById('orderImagesCLick').click()
  }
  showImages(){
    this.imageUrlArray=this.hospitalDetail.images
    //console.log(this.imageUrlArray)
    document.getElementById('orderImagesCLick').click()
  }
  bookHospital(){
    this.hospitalSvc.bookHospital(this.sendBookingData,this.hospitalDetail._id).subscribe(res=>{
     // document.getElementById('booking_doctor_trigge_doctor').click()
     localStorage.setItem('tab','hospitals')
     this.ngZone.run(()=>this.navigateTo('/user-orders'));
      
    },error=>{
      this.ngZone.run(()=>
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      }));
      
      
    }) 
  }
  navigateTo(url){
    this.router.navigate([url])
  }
  counter(i: number) {
    return new Array(i);
}
parseInt(number){
  return parseInt(number)
}
showTreatPopup(){
  document.getElementById('slot_popup_trigge_doctor').click()
  document.getElementById('treatment_popup_trigge_doctor').click()
}
closeSlotPopup(){
  document.getElementById('slot_popup_trigge_doctor').click()
}
getSlots(object,index){
  this.sendBookingData.bookingDate = object.sendDate
  
     this.showDateWithDay.map(showday=>{
       showday.selected = false
     })
     this.showDateWithDay[index].selected =true
     this.getHospitalDetail( this.route.snapshot.params.id,object.sendDate)
     this.bookingDay = object.day 
   }

}
